module.exports = __webpack_public_path__ + "static/media/MHRP39N0005.28676800.svg";